import { call } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { PrejoinResponse } from 'features/room/types';
import { SignalingSocket } from 'services/signaling';
import { getBrowserId } from 'utils/getBrowserId';
import { logger } from 'utils/logger';
import { setSentryIdentity } from 'utils/sentry/setSentryIdentity';
import { setSentryUserDetails } from 'utils/sentry/setSentryUserDetails';

export function* connectSignalingSaga(action: PayloadAction<PrejoinResponse>) {
  const {
    signallingUrl,
    signallingToken,
    user,
    settings: { joinScreenEnabled },
  } = action.payload;

  logger.remote().info(`Join screen is ${joinScreenEnabled ? 'enabled' : 'disabled'}`);
  yield call(setSentryIdentity, { participant_id: user.id });

  yield call(setSentryUserDetails, { role: user.role });

  const browserId: string = yield call(getBrowserId);

  yield call(SignalingSocket.connect, signallingUrl, signallingToken, browserId);
}
